import { parseSelectorToR3Selector } from '@angular/compiler/src/core';

export const EnglishTranslationEnum = {
    StartScreen: {
        h1: "Thank you for starting your business journey with us!",
        p1: "You are applying for a",
        yellowContent: "This application must be completed by an owner, director or partner as registered in the SSM. It should take less than 15 minutes",
        p2: "Before you continue, please note and prepare the following:",
        pb1: "Eligibility criteria",
        li1_1: "Your core business is",
        li1_2: "Shariah compliant",
        li1_3: "If not,",
        li1_4: "apply for a different account",
        li2: "Business must be registered as a sole proprietorship or an entity with up to 2 partners/directors",
        li3: "All applicants must be Malaysians and holders of the latest MyKad (with dual image/version 80k)",
        pb2: "Supporting information for verification",
        li4: "SSM Business Registration Number",
        li5: "Image of your signature",
        li6: "SSM report is updated with the latest list of owners, partners, directors/shareholders",
        p3_1: "If you are unable to meet any of these requirements, please",
        p3_2: "schedule an appointment",
        p3_3: "with us.",
        faq: {
            part1: "Click",
            part2: "here",
            part3: "for FAQ."
        },
        b1: "Start"
    },
    AppointmentScreen: {
        h1: "Please tell us your contact details",
        p1: "Please provide your details for us to arrange for an appointment with you.",
        label1: "Your company name",
        label2: "Business registration number",
        label3: "Business location",
        label4: "Preferred OCBC branch",
        label5: "Your name",
        label6: "Your mobile number",
        label7: "Your email address",
        b1: "Next",
        h2: "Thank you for your interest in the",
        p2: "We will be contacting you within the next business day for additional information.",
        pleaseSelect: "Please select"
    },
    TellUsScreen: {
        h1_1: "How do we contact you?",
        h1_2: "Please tell us who you are",
        label1: "Your name",
        label2: "Your mobile number",
        label3: "Your Email Address",
        p1: "Make sure the details you provide are accurate.",
        p2: "We will use these contact details to save and retrieve your application.",
        c1: "I agree that OCBC Bank will send SMSes and emails (which may contain clickable links) regarding this application and/or the account to the person above",
        b1: "Next",
        pleaseSelect: "Please select",
        numberError: {
            required: "Please enter your mobile number",
            minlength1: "Please enter at least ",
            minlength2: " characters",
            pattern: "Please enter valid format"
        },
        emailError: {
            required: "Please enter your email address",
            pattern: "Please enter valid email address"
        },
        noteTitle: "Note",
        note2: "The phone number and email address provided here will be used by OCBC Bank for any future contact / communication related to all my company / business / personal account(s) with OCBC Bank. For update / change of contact details, you may reach out to any OCBC branch for assistance.",
        p1c: "To proceed please verify the code below.",
        note1: "Enter the letters shown in the image",
        p2c: "Resend code",
        link1: "Get another code",
        modal: {
            h1: "Did you receive the SMS we sent?",
            p1 : {
                part1: "You will receive an SMS at",
                part2: "in 20 seconds.",
                part3: "Make sure your mobile phone is switched on."
            },
            p2: "If you did not receive the SMS, return to the previous screen and check that you provided the correct mobile number.",
            b1: "No",
            b2: "Yes",
        }
    },
    IdentifyYourCompanyScreen: {
        h1: "Identify your company",
        label1: "What is your business type?",
        label2: "Sole Proprietor/ Partnership",
        label3: "Sdn Bhd",
        label4: "New Business Registration Number",
        b1: "Search",
        popup: "12 digits SSM Registration Number e.g. 202101123456",
        error: "New Business Registration Number must be 12 digits.",
        noteBox: {
            part1: "I represent and warrant to OCBC Bank (Malaysia) Berhad and OCBC Al-Amin Bank Berhad (“Bank”) that I am duly authorized by the entity bearing the registration number above (“Applicant”) and its officers, and I shall click the ‘Search’ button below for the Bank to perform the search on the Applicant and its officers on the basis of my",
            part2: "representations and warranties",
            part3: "which I have read and confirm making the same."
        },
        errorLink: "Please view the link"
    },
    OTPScreen: {
        h1: "Verify your contact details",
        h1_2: "Retrieve your saved application",
        // p1: "Please enter the code that has been sent to the mobile number you gave us:",
        p1: "To proceed please verify the code below.",
        note1: "Enter the letters shown in the image",
        p2: "Resend code",
        link1: "Get another code",
        seconds: "seconds",
        b1: "Next",
        modalError: "You have no more attempts. You will be redirected to the initial screen.",
        modalError2: "You have exceeded the maximum attempt to request SMS OTP, please try again later.",
        otpError: "Please enter OTP numbers",
        otpError2: "OTP must be in the form of numbers"
    },
    PasscodeScreen: {
        h1: "Retrieve your application",
        p1: "Enter the passcode using the instructions we sent via email.",
        l1: "Passcode",
        b1: "Next",
        passCodeError1: 'Invalid passcode. Try again.',
        passCodeError2: {
            part1: '',
            part2: ' attempts left. Try again.'
        },
        passCodeError3: 'Maximum no. of attempts reached. Restart your application via the email we sent.'
    },
    ConfirmYourCompanyScreen: {
        h1: "Is this your company?",
        b1: "No",
        b2: "Yes",
    },
    CompanyDetailsInfoScreen: {
        h1: "Please check all your company details",
        label1: "Business name and Business Registration Number",
        label2: "Entity Type",
        label3: "Business address",
        label4: "Business nature",
        label5: "Owner(s)/ Partner(s)",
        label6: "Director(s)",
        label7: "Name",
        label8: "Identification Number",
        label9: "Old Identification Number",
        b1: "Correct",
        b2: "Incorrect",
        modal: {
            h1: "Sorry, your business is not eligible for OCBC eBiz Account-i",
            p1: "Would you like to apply for OCBC eBiz Account instead?",
            p2: "Why you will love this",
            l1: "100% online application process",
            l2: "Small initial deposit of RM500",
            l3: "Comes with a suite of financial tools",
            p3: "Who can apply",
            l4: "Businesses registered with Suruhanjaya Syarikat Malaysia (SSM) - inclusive of SME defined by SME Corporation Malaysia",
            l5: "Businesses own by Malaysian only",
            b1: "Yes",
            b2: "No"
        } 
    },
    CompanyNotFoundScreen: {
        p1: "We could not find any active company that matches your entry.",
        p2_1: "Please",
        p2_2: "search again",
        p2_3: "using your Business Type and New Business Registration No.",
        p3: "Unable to find your company?",
        p4_1: "Send us your contact details",
        p4_2: "to arrange for an appointment.",
    },
    InforUpdateRecordScreen: {
        h1: "We are sorry, but you need to update your SSM record first.",
        p1: {
            part1: "An accurate SSM record is required to open a business bank account with us.",
            part2:  "You can update your records at",
            part3: "www.ssm.com.my"
        },
        p2: "Do note that updates with SSM will take 2 days to be reflected.",
        p3: "If you have updated your SSM, please restart your application.",
        p4: {
            part1: "Or arrange for a",
            part2: "callback."
        }
    },
    BusinessDetailsScreen: {
        h1: "Business Details",
        label1: "Mailing address",
        edit: "Edit",
        ph1: "House number/unit/floor or building name",
        ph2: "Street or District",
        ph3: "City",
        label2: "Postal Code",
        label3: "State",
        label4: "Country",
        label5: "Main contact person",
        label2Error:"Invalid postal code",
        b1: "Next",
        pleaseSelect: "Please select",
        tooltip: "You are authorised to receive information (including Velocity@ocbc starter kit) and communicate information to the Bank. Your contact details will also be printed in the contact section of the Remittance Advice send to your beneficiary. Your account notifications for all your personal accounts with OCBC Bank will be sent to the above mobile number and email address."
    },
    AboutYourBusinessScreen: {
        h1: "About your business",
        label1: "Please confirm your principal activities:",
        label2: "Please tell us more about your business:",
        ph1: "Which goods or services do your offer, produce, trade or invest in? Where are your customers and suppliers located?",
        label3: "Please tell us your industry category:",
        ck1: "Manufacturing",
        ck2: "Services and other sectors" ,
        label4: "How many permanent employees does your business have?",
        label5: "Does your business deal in any of the following activities?",
        label6: "Which sector best describes your business?",
        label7: "Your principal activity:",
        li1: "Armament or weapons related industries",
        li2: "Casinos, junkets, betting or other gambling related businesses",
        li3: "Money services businesses",
        li4: "Virtual currencies",
        li5: "Forex Trader, multi-level marketing/ pyramid scheme, investment advisor/ business",
        li6_1: "",
        li6_2: "Shariah non-compliant",
        li6_3: "business activities",
        ck3: "No, none of the above",
        ck4: "Yes, some of the above",
        b1: "Save",
        b2: "Next",
        pleaseSelect: "Please select"
    },
    AboutYourBusinessInfoScreen: {
        h1: "About your business",
        label1: "Your business mainly operates in",
        label2: "Where does the initial funding for this account come from?",
        ck1: "Business Revenue",
        ck2: "Income from employment",
        ck3: "Proceeds from investments",
        ck4: "Others",
        p1: "Please explain:",
        label3: "Annual business turnover (RM)",
        label4: "Majority of your sales originate from:",
        label5: "Are you the ultimate owner and sole decision maker of the company?",
        ck5: "Yes",
        ck6: "No",
        b1: "Save",
        b2: "Next",
        pleaseSelect: "Please select",
        fundListError: "Please select funding sources",
        turnOverError: "Please enter Annual business turnover",
        ownerListError: "Please select owner"
    },
    TaxStatusInfoScreen: {
        h1: "Tax Status",
        label1: "Where do you pay taxes?",
        ck1: "Malaysia",
        ck2: "USA",
        label2: "What is your Tax Identification Number(TIN)",
        ck3: "Others",
        label3: "Country",
        label4: "Which statement best describes your business?",
        label5: "My business is an active business",
        label6: "My business is a passive business",
        label7: "Tax registration details",
        p1: "Generates 50% or more of its business revenue from business operations (For example, Wholesale Trade, F&B, Retail sale or other professional services)",        
        p2: "Generates 50% or more of its business revenue from passive income (For example Investment, Rents, Interest, Dividends and Royalties)",
        p3: "In accordance with the e-invoicing initiative introduced by the Inland Revenue Board of Malaysia (IRBM), all current and new business account users are required to provide their entity’s Malaysia Tax Identification Number (TIN) and Malaysia Sales and Service Tax (SST) registration number.",
        p4: "TIN",
        p5: "SST",
        
        b1: "Save",
        b2: "Next",
        pleaseSelect: "Please select",
        taxMinLenErr: "Please enter at least 5 characters."
    },
    AboutYourTransactionScreen: {
        h1: "About your transactions",
        label1: "The account will be mainly used for",
        p1: "Please explain:",
        label2: "Please provide the name of your current or expected customers.",
        p2: "(1 name per field up to 5 names)",
        ck1: "I do not have the names yet",
        label3: "Add customer",
        ph: "Enter Name",
        label4: "Please provide the names of your current or expected suppliers.",
        label5: "Add supplier",
        label6: "Where are your customers and suppliers located?",
        p3: "(up to 5 countries)",
        label7: "Add Country",
        label8: "Where is the originating country and end-destination of your goods/services?",
        label9: "Do you deal with any of these regions?",
        label10: "What is your total number of expected transactions per month?",
        label11: "What is your expected total transaction amount per month?",
        infoBox: "These are the countries where your suppliers source from and customers sell to. E.g. your supplier in Thailand may source jade from Myanmar for you.",
        b1: "Save",
        b2: "Next",
        pleaseSelect: "Please select",
        selectType: "Select Type"
    },
    BusinessBankingServiceScreen : {
        h1: "Business Banking Services",
        label1: "Preferred OCBC branch location",
        label2: "State",
        label3: "Branch",
        label4: "Business Internet & Mobile Banking (OCBC Velocity)*",
        p1: "* 1 person to create & approve transaction (Applicable to sole-proprietor & single-director company)",
        p2: "2 person to create & approve transaction (Applicable to partnership & 2-directors company)",
        p3: "DuitNow Linkage",
        ck1: "Link my BRN to this OCBC eBiz Account",
        ck1_2: "Link my BRN to this OCBC eBiz Account-i",
        ck1_3: "Link my BRN to this Business Access Account",
        ck1_4: "Link my BRN to this Business Signature Account",
        p4: "* By selecting DuitNow, you are authorising the Bank to register or switch your DuitNow ID to OCBC upon creation of the account.",
        p5: "OCBC OneCollect (Collection Through QR)",
        ck2: "I wish to apply for OCBC OneCollect",
        p6_1: "* To understand more about OCBC OneCollect, please visit",
        p6_2: "OCBC OneCollect.",
        p7: "* Kindly note a Malaysian mobile number is required for the sign up of OCBC OneCollect.",
        p8: {
            islamic: "Business debit card-i(s)",
            others: "Business debit card(s)"
        },
        p9: {
            part1: "One",
            part2: "Both",
            part3: "of your entries requires your attention.",
            part4: "We accept up to 19 characters for the name on your card",
        },
        card1: "",
        card2: "'s Card",
        p10: {
            islamic: "This is what will appear on your debit card-i. Please check carefully.",
            others: "This is what will appear on your debit card. Please check carefully."
        },
        link1: "Edit card",
        p11: "Registered company name",
        p12: {
            part1: "Name to display on card",
            part2: "(Must contain the name shown in your identification documents)"
        },
        p13: "ATM Daily Withdrawal",
        p14: "Daily Purchase Payments",
        ck3: "Contactless Purchase",
        info1: "This refers to a secure and wireless method of payment for consumers to purchase products and services using their debit card. The chip-embedded card allows for transactions to be made by tapping the card on the merchant’s point-of-sale terminal.",
        ck4: "Online Transactions",
        info2: "Online transaction refers to a payment method in which money is transmitted via the internet, over an electronic network.",
        b1: "Okay",
        link2: "Remove Card",
        link3: "Add card",
        p15: {
            islamic: "To have us issue a debit card to someone else, please visit any OCBC Bank branch",
            others: "To have us issue a debit card to someone else, please visit any OCBC Bank branch"
        },
        p16: {
            islamic: "Note: If you are an existing cardholder of an OCBC Business Debit Card-i (Islamic debit card), you will not be issued additional Business Debit Card(s) with any new OCBC business current account/-i opened.",
            others: "Note: If you are an existing cardholder of an OCBC Business Debit Card (conventional debit card), you will not be issued additional Business Debit Card(s) with any new OCBC business current account/-i opened."
        },
        b2: "Save",
        b3: "Next",
        pleaseSelect: "Please select"
    },
    SignatureScreen: {
        h1: "Signature and other personal details",
        label1: {
            part1: "Upload",
            part2: "'s signature (JPEG, max 5MB)",
            part3: "Your signature may be used to verify your cheques."
        },
        dropbox: {
            p1: {
                part1: "Supported file type: JPG",
                part2: "Max file size: 5MB"
            },
            h4: "Drag and drop file here",
            p2: "----- or -----",
            p3: "Select file",
            b1: "Re-upload",
            b2: "Rotate",
            error: "Please select an image with format .jpg or .jpeg"
        },
        signpad: {
            p1: "To ensure accurate signature records with the bank, please use your device's digital pen.",
            b1: "Clear"
        },
        error1: "Please sign your signature.",
        error2: "Please upload your signature.",
        label2: "Old Identification Number (Optional)",
        info1: "Your old identification number can be found on the back of your new identity card.",
        error3: "Old identification number is required.",
        error4: "Invalid input. Please provide valid old identification number.",
        label3: "Please indicate your race:",
        error5: "Please select your race.",
        label4: "Are you a Bumi or Non-Bumi?",
        error6: "Please select if you are a Bumi or Non-Bumi",
        b1: "Upload",
        b2: "Sign",
        pleaseSelect: "Please select",
        nonBumi: "Non-Bumi",
        b3: "Save",
        b4: "Next"    
    },
    CompanyConstitutuionScreen: {
        h1: "Company Constitution and Board Resolution",
        p1: "Please read the following information carefully and confirm that everything is correct.",
        h4: "Company Constitution",
        p2: {
            part1: "Your company",
            part2: "does not",
            part3: "have a Constitution or Your Company's Constitution",
            part4: "use the format given in Table A of the previous Companies Act 1965:"
        },
        ck1: "True",
        ck2: "False",
        p3: 'You may also select "True" if your constitution document satisfies the following:',
        p4: "The quorum of directors meeting clause must be consistent with the actual  number of directors appointed.",
        p5: "If you are a one director company, the director must be able to pass a board resolution by recording it and signing the record.",
        h42: "Board Resolution:",
        p6: {
            part1: "The OCBC Bank standard resolution",
            part2: "(Private Limited / Public Company)",
            part3: " has been passed at a Meeting of Board Directors duly convened on",
            part4: " (at which a quorum was present throughout).",
            part5: "The following person(s) are appointed to act on behalf of the company as the authorised person and signatory of the account(s) to be opened."
        },
        p7: "The authorised persons may:",
        ul: {
            li1: "Open and close accounts",
            li2: "Apply for account and banking services, including but not limited to electronic, cash management, remittance and payment, and trade related services",
            li3: " Appoint authorised users of the respective services",
            li4: "Appoint authorised signatories",
            li5: "Borrow and grant security",
            li6: "Verify specimen signatures",
            li7: "Notify of changes in authorised persons",
            li8: "Communicate and sign electronically"
        },
        p8: {
            part1: "Signing Condition:",
            part2: "Singly",
            part3: "Both to sign"
        },
        ck3: "I confirm all of the above.",
        b1: "Next"
    },
    DeclarationScreen: {
        h1: "Information on The Customer",
        p1: "The Company/Firm/Business consents, and represents and warrants that it has obtained/will obtain the consent of  the Authorised Person(s), Authorised Signatory(ies) and Authorised User(s) appointed from time to time, to disclose their contact details (excluding the information relating to the Company/Firm/Business’s affairs or accounts) to OCBC Group* for marketing of products and services distributed by the OCBC Group*, which may be of interest to the Company/Firm/Business. The Company/Firm/Business may at any time withdraw such consent.",
        p1_2: "*OCBC Group means OCBC Bank (Malaysia) Berhad and its related corporations in Malaysia.",
        ck1: "Yes",
        ck2: "No",
        h1_2: "Declaration and Agreement",
        p2: "By clicking the below, I confirm that I have read, understood and accept the following:",
        p3: {
            part1: "I note that the key contract terms affecting my obligations for all the banking services signed up in the application of the current account have been adequately explained to me in the",
            part2: "Product Disclosure Sheets",
            part3: "which I have read."
        },
        p4: "I understand that I have the right to enquire and discuss with OCBC Bank officers if I do not understand the terms and conditions, and I have done so.",
        viewError: "Please view all links",
        b1: "Agree"
    },
    DirectorReviewScreen: {
        h1: "Final Review",
        yellowContent: "You can edit by clicking the pen icon.",
        label1: "Account selected",
        h1_2: "Business Details",
        label2: "Business name",
        label3: "Registration number",
        label4: "Constitution",
        label5: "Mailing address",
        label6: "Name",
        label7: "Email address",
        label8: "Mobile number",
        h1_3: "Business Banking Services",
        h1_4: "Preferred OCBC Branch",
        li1: "State",
        li2: "Branch",
        label9: "Services",
        li3: "Business Internet & Mobile Banking (OCBC Velocity)",
        li4: "DuitNow",
        li7: "eAlerts",
        li5: "OCBC OneCollect (Collection Through QR)",
        li6: {
            islamic: "Business Debit Card-i",
            others: "Business Debit Card"
        },
        h1_5: "Signature",
        h1_6: "This application will be saved and retrievable from the email of",
        b1: "Correction Needed",
        b2: "Confirm"
    },
    ThankYouApplication: {
        h1: "One more step",
        p1: "To complete your application, you will need to verify your identity by scanning the QR code below which will redirect you to the eKYC verification portal which is owned and developed by CTOS. This will take about 5 minutes.",
        p2: "To complete your application, you will need to verify your identity by tapping “Verify identity” which will redirect you to the eKYC verification portal which is owned and developed by CTOS. This will take about 5 minutes.",
        p3: "will also receive an email to do the same.",
        p4: "Your Application Reference Number is",
        b1: "Verify identity",
        p5: "Have Questions?",
        p6: "You may contact us at: 603 8317 5200 or",
        p7: "Frequently Asked Questions",
        p8: "You may contact us at:",
        number: "603 8317 5200",
        p10: "or",
        p11: "To complete your application, you will need to verify your identity. Within the next few hours, you will receive an email with instructions on how to do so."
    },
    LastStepScreen: {
        h1: "Application review by other director",
        label1: {
            part1: "The application will be sent to your other director for review. Please enter",
            part2: "'s details"
        },
        label2: "Mobile number",
        label3: "Email address",
        b1: "Submit",
        numberError: {
            required: "Please enter your mobile number",
            minlength1: "Please enter at least ",
            minlength2: " characters",
            pattern: "Please enter valid format"
        },
        emailError: {
            required: "Please enter your email address",
            pattern: "Please enter valid email address"
        },
        noteTitle: "Note",
        note2: "The phone number and email address provided here will be used by OCBC Bank for any future contact / communication related to all my company / business / personal account(s) with OCBC Bank. For update / change of contact details, you may reach out to any OCBC branch for assistance."
    },
    EndLastStepScreen: {
        h1: "Pending review",
        p1: {
            part1: "After",
            part2: "reviews the application, you will both receive an email to verify your identity."
        },
        p2: "Your Application Reference Number is",
        p3: "Have Questions?",
        p4: {
            part1: "Your changes have been successfully sent to",
            part2: "to review and confirm."
        },
        p5: "Frequently Asked Questions",
        p6: "You may contact us at:",
        number: "603 8317 5200",
        p8: "or"
    },
    CorrectionRequestScreen: {
        h1: "Correction request sent",
        p1: {
            part1: "The application has been sent back to",
            part2: "for corrections."
        },
        p2: "Your Application Reference Number is",
        p3: "Have Questions?",
        p5: "Frequently Asked Questions",
        p6: "You may contact us at:",
        number: "603 8317 5200",
        p8: "or"
    },
    ThankYouScreen: {
        h1_1: "Thank you for your application!",
        p1: "Regretfully, you do not qualify to open a business account instantly online. We will arrange an appointment with you.",
        p2: "Regretfully, you do not qualify to open a business account-i instantly online. We will arrange an appointment with you.",
        h1_3: "We are sorry, but you need to update your SSM record first.",
        p3: "You can update your records at",
        p4: {
            part1: "Send us your contact details",
            part2: "to arrange for an appointment.",
        }        
    },
    Footer: {
        s1: "Copyright OCBC Bank (Malaysia) Berhad (199401009721 / 295400-W)",
        s2: "OCBC Al-Amin Bank Berhad (200801017151 / 818444-T). All rights reserved.",        
        copyRight: "Copyright"
    }
}